import { useCallback, useEffect, useState } from "react";
import { errMsg, isGated } from "@/lib/api";

export function useLoad(fn, deps = []) {
  const [state, setState] = useState({ data: null, loading: true, error: null, gated: null });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const load = useCallback(async () => {
    try {
      const data = await fn();
      setState({ data, loading: false, error: null, gated: null });
    } catch (e) {
      setState({ data: null, loading: false, error: errMsg(e), gated: isGated(e) ? e.response.data.detail : null });
    }
  }, deps);
  useEffect(() => {
    load();
  }, [load]);
  return { ...state, reload: load };
}
